import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setMakerCollateral} from '../../../../actions/ui/marketplace';
import {removeTaker} from '../../../../actions/orderbook/matchingEngine';

import {lowestDenom} from '../../../../config';
import $ from 'jquery'

class TakeOrders extends Component {
  constructor(){
    super();
    this.state = {amount:0,to:0,name:"BTC"};
  }
  onClick(index){
    this.props.removeTaker(index)
  }
  render() {

    let totalSends = 0;
    let totalReceives = 0;
    let totalCollateral = 0;

    var items =
    this.props.takeOrders.map(({receivesToChain,sendsFromChain,amount,price,type,id,cml,takeAmount,nrgUnit,collateralizedNrg,blockHeight,depositLeft,settleLeft},i) => {
      if(takeAmount ===  null || takeAmount == 0) takeAmount = amount;
      let modifiedCollateral = collateralizedNrg * takeAmount / amount;
      totalCollateral += modifiedCollateral
      totalSends+= parseFloat(takeAmount)
      totalReceives+= parseFloat(takeAmount*price)

      return (
        <tr className='takerItem' style={{cursor:'pointer',borderBottom:'none'}} onClick={this.onClick.bind(this,i)}>
          <td style={{width:'70px'}}>Taker</td>
          <td>{takeAmount} {receivesToChain.toUpperCase()}</td>
          <td>{takeAmount*price} {sendsFromChain.toUpperCase()}</td>
          <td>{modifiedCollateral} NRG</td>
          <td >
            <span style={{float:'right'}}>
              <i className="material-icons" style={{color: "black",fontSize:"1.2em",lineHeight:'26px'}}>close</i>
            </span>
            <span style={{maxWidth:'30px'}}>{settleLeft} </span>
          </td>
        </tr>
      );
    });

    let makerItem = null;
    if(this.props.makerAmount && this.props.price != 0){
      totalCollateral += parseFloat(this.props.makerCollateral)
      totalSends += parseFloat(this.props.sendsUnit)
      totalReceives += parseFloat(this.props.receivesUnit)
      let makerBorderBottom = items.length > 0 ? '1px solid grey' : 'none'

      makerItem = (
        <tr style={{borderBottom:makerBorderBottom}} key={`${this.props.makerAmount}-${this.props.price}`}>
          <td style={{width:'70px'}}>Maker</td>
          <td>{this.props.sendsUnit} {this.props.sendsFromChain.toUpperCase()}</td>
          <td>{this.props.receivesUnit} {this.props.receivesToChain.toUpperCase()}</td>
          <td><input style={{textAlign:'center',color:'black'}} id='makerInput' size={12} onChange={this.onChange.bind(this)}></input> NRG</td>
          <td>in {this.props.settlement} Blocks</td>
        </tr>
      )
    }
    let maxHeight = makerItem != null ? '57px' : '77px'
    return (
      <div className='col s12' style={{maxHeight:'300px',overflowY:'scroll'}}>
        <div style={{}}>
        <table className="black-text orderDetails" style={{tableLayout:"fixed"}}>
          <thead>
            <tr>
              <th style={{width:'70px'}}>Type</th>
              <th>Send</th>
              <th>Receive</th>
              <th>Collateral</th>
              <th>Settlement</th>
            </tr>
          </thead>
        </table>


        {makerItem != null &&
          <table className="black-text orderDetails" style={{tableLayout:"fixed"}}>
            <tbody style={{lineHeight:'30px',padding:'0px'}}>
              {makerItem}
            </tbody>
          </table>
        }

        {items.length > 0 &&
          <div style={{maxHeight,overflowY:'scroll',width:'102%'}} className="takerItems">
          <table className="black-text orderDetails" style={{tableLayout:"fixed"}}>
            <tbody style={{lineHeight:'30px',padding:'0px'}}>
              {items}
            </tbody>
          </table>
          </div>
        }

        {(makerItem != null && items.length > 0 || items.length > 1) &&
          <table className="black-text orderDetails" style={{tableLayout:"fixed"}}>
            <tbody style={{lineHeight:'30px',padding:'0px'}}>
              {this.totalAmount(totalSends,this.props.sendsFromChain,totalReceives,this.props.receivesToChain,totalCollateral)}
            </tbody>
          </table>
        }

        {this.props.spending == 0 && this.props.makerAmount == 0 && this.otherwise()}
        </div>
      </div>
		)
  }
  onChange(e){
    let val = e.target.value.replace(/\D/g,'');
    $('#makerInput')[0].value = val
    this.props.setMakerCollateral(val,()=>{})
  }
  componentDidUpdate(){
    let input = $('#makerInput')[0]
    if(input){
      if(input.value == '' && this.props.makerCollateral != 0) input.value = this.props.makerCollateral

      input.addEventListener('input', resizeInput); // bind the "resizeInput" callback on "input" event
      resizeInput.call(input); // immediately call the function

      function resizeInput() {
        this.style.width = this.value.length+1 + "ch";
      }
    }
  }
  otherwise(){
    return (
      <h6 className='grey-text' style={{fontSize:'10px',marginTop:'5px'}}>
        Set Price and Amount to view the details of your order
      </h6>
    )
  }
  totalAmount(sendsUnit,sendsFromChain,receivesUnit,receivesToChain,collateral){
    return (
      <tr style={{borderTop:'1px solid grey',borderBottom:'none'}} key={`totalAmount`}>
        <td style={{width:'70px'}}></td>
        <td style={{opacity:1}}>{sendsUnit} {sendsFromChain.toUpperCase()}</td>
        <td style={{opacity:1}}>{receivesUnit} {receivesToChain.toUpperCase()}</td>
        <td style={{opacity:1}}>{collateral} NRG</td>
        <td></td>
      </tr>
    )
  }
}

function mapStateToProps(state,props) {

  let {denomination,asset,type} = state.ui_marketplace.market;
  let sendsFromChain = state.ui_marketplace.orderType === 'BUY' ? denomination : asset;
  let receivesToChain = state.ui_marketplace.orderType === 'BUY' ? asset : denomination;
  let receivesUnit = state.ui_marketplace.orderType == 'BUY' ? state.ui_marketplace.makerAmount : state.ui_marketplace.makerAmount*state.ui_marketplace.price
  let sendsUnit = state.ui_marketplace.orderType == 'SELL' ? state.ui_marketplace.makerAmount : state.ui_marketplace.makerAmount*state.ui_marketplace.price

  return {
    market: state.ui_marketplace.market,
    orderType: state.ui_marketplace.orderType,
    price: state.ui_marketplace.price,
    makerAmount: state.ui_marketplace.makerAmount,
    settlement:state.settings.settings.settlement,
    receivesUnit,
    sendsUnit,
    sendsFromChain,
    receivesToChain,
    makerCollateral: state.ui_marketplace.makerCollateral,
    spending: state.ui_marketplace.spending,
    takeOrders: state.ui_marketplace.takeOrders
  };
}

export default connect(mapStateToProps, {setMakerCollateral,removeTaker})(TakeOrders);
